<template>
  <div class="actions-container">
    <BbBtn
      class="action-button"
      size="x-small"
      type="icon"
      icon="chevron-up"
      icon-size="small"
      no-background
      @click="emit('update:prevPage')"
    ></BbBtn>
    <BbBtn
      class="action-button"
      size="x-small"
      type="icon"
      icon="chevron-down"
      icon-size="small"
      no-background
      @click="emit('update:nextPage')"
    ></BbBtn>
    <BbInput class="current-page" size="x-small" :value="currentPage" readonly />
    <span class="total-pages">{{ '/ ' + totalPages }}</span>
    <BbBtn
      class="action-button"
      size="x-small"
      type="icon"
      icon="zoomout"
      icon-size="small"
      no-background
      @click="emit('update:zoomOut')"
    ></BbBtn>
    <BbBtn
      class="action-button"
      size="x-small"
      type="icon"
      icon="zoomin"
      icon-size="small"
      no-background
      @click="emit('update:zoomIn')"
    ></BbBtn>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  emits: ['update:zoomIn', 'update:zoomOut', 'update:nextPage', 'update:prevPage', 'change:currentPage'],
  setup(props, { emit }) {
    return {
      emit,
    };
  },
};
</script>

<style scoped lang="scss">
.actions-container {
  display: flex;
  gap: $bb-spacing-1;
  background-color: $bb-neutral-1;
  position: absolute;
  bottom: $bb-spacing-3; /* Adjust the position from the bottom */
  left: 50%;
  transform: translateX(-50%); /* Center the toolbar */
  align-items: center;
  justify-content: center;
  padding: $bb-spacing-1 $bb-spacing-3;
  color: white;
  border-radius: $bb-spacing-5; /* Rounded corners */
  z-index: 1000; /* Ensure it's above other content */

  .action-button {
    :deep(.v-btn__content) {
      color: $bb-neutral-0;
    }
  }

  .current-page {
    color: $bb-neutral-1;
    background-color: $bb-neutral-0;
    border-radius: $bb-spacing-1;
    min-width: $bb-spacing-10;
  }

  .total-pages {
    @include bb-medium-text-styles('md');
  }
}
</style>
